module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Dear Mum")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Thank you for all your help. I couldn’t have done it without you.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Love Laura x")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ede7c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 60
// module chunks = 0